/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FeaturedInputs */

const en_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FEATURED`)
};

const es_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DESTACADO`)
};

const fr_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EN VEDETTE`)
};

const de_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HERVORGEHOBEN`)
};

const ja_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おすすめ`)
};

const zh_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐`)
};

const ar_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مميز`)
};

const id_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UNGGULAN`)
};

const it_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IN EVIDENZA`)
};

const ru_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ИЗБРАННОМ`)
};

const pt_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DESTAQUE`)
};

const ko_featured = /** @type {(inputs: FeaturedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추천 항목`)
};

/**
* | output |
* | --- |
* | "FEATURED" |
*
* @param {FeaturedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const featured = /** @type {((inputs?: FeaturedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FeaturedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_featured(inputs)
	if (locale === "es") return es_featured(inputs)
	if (locale === "fr") return fr_featured(inputs)
	if (locale === "de") return de_featured(inputs)
	if (locale === "ja") return ja_featured(inputs)
	if (locale === "zh") return zh_featured(inputs)
	if (locale === "ar") return ar_featured(inputs)
	if (locale === "id") return id_featured(inputs)
	if (locale === "it") return it_featured(inputs)
	if (locale === "ru") return ru_featured(inputs)
	if (locale === "pt") return pt_featured(inputs)
	return ko_featured(inputs)
});